import axios from "axios";
import React, { useContext, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import loading_animation from "../../files/animations/pulsing-stripes-divelit-plum.svg";

// translations
import { ValidationError } from "yup";
import CalculatorContext from "./CalculatorContext";
import { formSchema } from "./validation/FormValidation";

export default function Form() {
  const { setSubmitForm, translation, language, questions, userAnswers } =
    useContext(CalculatorContext);

  const [inputEmail, setInputEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isErrorMsg, setIsErrorMsg] = useState(false);
  const [checkBoxConsent, setCheckBoxConsent] = useState(false);
  const [formMsg, setFormMsg] = useState("");

  const handleSubmitForm = async () => {
    const data = new FormData();

    setIsLoading(true);
    data.append("email", inputEmail);
    data.append("questions", JSON.stringify(questions));
    data.append("userAnswers", JSON.stringify(userAnswers));

    try {
      await formSchema.validate(
        { email: inputEmail, consent: checkBoxConsent },
        { abortEarly: false }
      );
      axios.post("/api/calculator/form", data, {
        headers: {
          "Content-type": "multipart/form-data",
        },
        params: {
          lang: language,
        },
      });

      setIsLoading(false);
      setSubmitForm(true);
    } catch (error) {
      if (error instanceof ValidationError) {
        setIsErrorMsg(true);
        setIsLoading(false);
        if (error.inner[0].params?.path === "consent") {
          setFormMsg(translation.form.consent_error);
        } else {
          setFormMsg(translation.form.email_invalid_error);
        }
      }
      return;
    }
  };

  return (
    <>
      <div className="w-full d-flex flex-column justify-content-center align-items-center">
        <h4>{translation.form.title}</h4>
        <div>
          {/* {inputMsg} */}
          <Container className="pt-3 pt-lg-5 pb-3 pb-lg-5">
            <form
              className="paragraph-small"
              method="post"
              encType="multipart/form-data"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmitForm();
              }}
            >
              <Row className="scroll-anim-750">
                <Col xs={12} sm={12} lg={12} className="">
                  <input
                    className="mt-4 mt-lg-0 form-input-style form-input-style-inverse"
                    id="email"
                    type="text"
                    name="email"
                    style={{ width: "100%" }}
                    placeholder={translation.form.email}
                    value={inputEmail}
                    onChange={(e) => setInputEmail(e.target.value)}
                    required
                  />
                </Col>
              </Row>
              <Row className="scroll-anim-1500">
                <Col xs={12} sm={12} lg={12} className="mt-4 mt-md-4">
                  <div className="d-flex flex-row">
                    <label className="checkbox-container-plum">
                      <input
                        type="checkbox"
                        name="consent"
                        checked={checkBoxConsent}
                        onChange={(e) => setCheckBoxConsent(e.target.checked)}
                        required
                      />
                      <span className="checkmark-plum checkmark-plum-inverse"></span>
                    </label>
                    <div className="" style={{ lineHeight: "2rem" }}>
                      {translation.form.consent.part1}
                      <a
                        className="link-href"
                        href={process.env.PUBLIC_URL + "/pdf/" + translation.form.gdpr}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {translation.form.consent.part2}
                      </a>
                      <span className="paragraph-small">{translation.form.consent.part3}</span>
                    </div>
                  </div>
                  <p className="mt-4 paragraph-extra-small text-end">{translation.form.required}</p>
                </Col>
              </Row>
              <Col className="scroll-anim-1000 mt-4">
                <Col xs={"auto"} sm={"auto"} className="">
                  <a
                    className="button-wo-border bg-divelit-plum-70 paragraph-small"
                    onClick={handleSubmitForm}
                  >
                    {translation.form.submit} <img className="button-arrow"></img>
                  </a>
                </Col>
                <Col xs={"auto"} sm={"auto"} className="form-message-box mt-2 mt-lg-0">
                  {isLoading ? (
                    <img src={loading_animation} className="form-loading-animation" />
                  ) : (
                    <span>{formMsg}</span>
                  )}
                </Col>
              </Col>
            </form>
          </Container>
        </div>
      </div>
    </>
  );
}
